<template>
  <div class="train_detial">
    <div class="left_tab">
      <div class="tab_header"><span class="button" @click="goBack"><i class="el-icon-back"></i>返回</span></div>
      <div class="tab_item" :class="currentTab==item.id?'active_tab_item':''" v-for="item in tabData" :key="item.id">
        {{ item.name }}
      </div>
    </div>
    <el-scrollbar style="height: 100%;flex: 1;width: 0;">
      <div class="right_content">
        <div class="video_content">
          <div class="video_box">
            <video class="video" controls="true" src="../../../../assets/img/ceshi/show_video.mp4"></video>
          </div>
          <div class="show_train_detial">
            <div class="detial_box">
              <div class="title">训练内容</div>
              <div class="train_info">HFP品牌风排版课程，专为追求设计美学与品牌调性融合的学员量身打造！本课程深度解析HFP品牌视觉体系精髓，从色彩搭配、字体选择到版式布局，全方位传授如何通过排版设计精准传递品牌气质与核心价值。无论是打造高级感、简约风还是个性化品牌视觉，课程将结合实战案例与前沿设计趋势，助你掌握品牌专属排版技巧，轻松提升设计作品的辨识度与商业价值，让每一份设计都成为品牌故事的完美注脚！</div>
              <div class="publish_time">发布时间：2025-5-30 10:38</div>
              <div class="trouble_level">难度等级：一般</div>
            </div>
            <div class="footer_button">
              <div class="button download" @click="downloadFile"><i class="el-icon-download"></i>资料下载</div>

              <el-upload class="upload-demo" :show-file-list="false" action="https://jsonplaceholder.typicode.com/posts/" multiple :limit="1" :on-exceed="handleExceed" :on-progress="handleProgress" :file-list="fileList">
                <div class="button upload"><i class="el-icon-upload2"></i>上传作品</div>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="works_box">
          <div class="works_content">
            <div class="header_box">
              <div class="box">
                <div class="tab_item" :class="currentWorkTab==item.id?'active_tab_item':''" v-for="item in workTabData" :key="item.id" @click="activeWorkTab(item)">{{ item.label }}</div>
              </div>
            </div>
            <div class="content_box">
              <!-- <div v-if="currentWorkTab==1" class="no_data">
                <img src="../../../../assets/img/company/detial/no_work.png" alt="">
                暂无作品

              </div>
              <div v-else class="no_data">
                <img src="../../../../assets/img/company/detial/no_sort.png" alt="">
                暂无排名
              </div> -->
              <div v-if="currentWorkTab==1" class="works_data_box">
                <div class="works_data">
                  <div class="work_item" v-for="item in WorksData">
                    <img :src="item.img" alt="">
                    <div>{{ item.name }}</div>
                  </div>
                </div>
              </div>
              <div v-else style="padding: 33px 12px;box-sizing: border-box;">
                <el-table :header-cell-style="{fontWeight: 'normal',height: '48px', color: '#4A5568', background: '#F4F4F7','border-radius': '5px 5px 5px 5px'}" :cell-style="{fontSize: '14px',color: '#333'}" :data="tableData"
                  style="width: 100%">
                  <el-table-column prop="noun" label="名次">
                  </el-table-column>
                  <el-table-column prop="name" label="参赛者">
                  </el-table-column>
                  <el-table-column prop="submit_time" label="提交时间">
                  </el-table-column>
                  <el-table-column prop="score" label="分数" width="100px">
                  </el-table-column>
                </el-table>

              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>

  </div>
</template>

<script>
import { Progress } from "element-ui";

export default {
  name: "",
  data() {
    return {
      currentTab: 2,
      tabData: [
        {
          name: "新媒体运营",
          id: 1,
        },
        {
          name: "HFP品牌风排版",
          id: 2,
        },
        {
          name: "妮维雅京东直播脚本策划",
          id: 3,
        },
        {
          name: "迎新话术制定",
          id: 4,
        },
        {
          name: "电商APP内容选题",
          id: 5,
        },
        {
          name: "内容排期",
          id: 6,
        },
        {
          name: "短视频剪辑古风类",
          id: 7,
        },
        {
          name: "短视频剪辑-动漫类",
          id: 8,
        },
      ],
      currentWorkTab: 1,
      workTabData: [
        {
          label: "本期作品",
          id: 1,
        },
        {
          label: "本期排名",
          id: 2,
        },
      ],
      WorksData: [
        {
          img: require("@/assets/img/company/detial/image1.png"),
          name: "银灰色护肤品",
        },
        {
          img: require("@/assets/img/company/detial/image2.png"),
          name: "滋润补水-自然美肌作品banner",
        },
        {
          img: require("@/assets/img/company/detial/image3.png"),
          name: "奢宠护肤 抗氧修护作品",
        },
        {
          img: require("@/assets/img/company/detial/image4.png"),
          name: "肌肤水润有光彩2025作品",
        },
      ],
      tableData: [
        {
          noun: 1,
          name: "王大顺",
          submit_time: "2025-06-14 17:40",
          score: 98,
        },
        {
          noun: 2,
          name: "李小英",
          submit_time: "2025-06-15 12:17",
          score: 92,
        },
        {
          noun: 3,
          name: "胡雄",
          submit_time: "2025-06-14 09:26",
          score: 91,
        },
        {
          noun: 4,
          name: "张烨",
          submit_time: "2025-06-15 15:37",
          score: 88,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    activeWorkTab(item) {
      this.currentWorkTab = item.id;
    },
    downloadFile() {
      const a = document.createElement("a");
      a.href = "/sucai.zip";
      a.download = "素材.zip";
      a.click();
    },
    handleExceed() {
      this.$message.success("上传成功");
    },
    handleProgress(event, file, fileList) {
      if (event.percent == 100) {
        this.$message.success("上传成功");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang='scss' scoped>
.train_detial {
  width: 100%;
  height: calc(100vh - 105px);
  display: flex;
  .left_tab {
    width: 329px;
    flex-shrink: 0;
    height: 100%;
    background: #36393d;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    .tab_header {
      display: flex;
      align-items: center;
      height: 56px;
      padding-left: 20px;
      box-sizing: border-box;
      .button {
        display: flex;
        align-items: center;
        cursor: pointer;
        .el-icon-back {
          font-size: 18px;
          margin-right: 2px;
        }
      }
    }
    .tab_item {
      display: flex;
      align-items: center;
      height: 56px;
      padding-left: 20px;
      box-sizing: border-box;
    }
    .active_tab_item {
      background: #4b5053;
    }
  }
  .right_content {
    width: 100%;

    .video_content {
      width: 100%;
      display: flex;
      height: 701px;
      .video_box {
        flex: 1;
        width: 0;
        height: 100%;
        background: #000000;
        .video {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .show_train_detial {
        width: 328px;
        flex-shrink: 0;
        height: 100%;
        background: #3b3d41;
        .detial_box {
          width: 100%;
          padding: 40px 21px 21px 22px;
          box-sizing: border-box;
          border-bottom: 1px solid #1c1c1d;
          .title {
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .train_info {
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 20px;
            word-wrap: break-word;
          }
          .publish_time {
            font-weight: 400;
            font-size: 12px;
            color: #8e9093;
            margin-bottom: 3px;
          }
          .trouble_level {
            font-weight: 400;
            font-size: 12px;
            color: #8e9093;
          }
        }
        .footer_button {
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .button {
            width: 125px;
            height: 44px;
            border-radius: 4px 4px 4px 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 13px;
            cursor: pointer;
            i {
              font-size: 18px;
              margin-right: 2px;
            }
          }
          .download {
            background: #2b6fc9;
            color: #fff;
          }
          .upload {
            background: #b8ceeb;
            color: #4d96fb;
          }
        }
      }
    }
    .works_box {
      width: 100%;
      min-height: 441px;
      padding: 33px 40px 20px 56px;
      background: #f6f6f8;
      box-sizing: border-box;
      .works_content {
        width: 100%;
        min-height: 388px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        .header_box {
          width: 100%;
          padding: 39px 20px 0 20px;
          box-sizing: border-box;
          .box {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #e6e7ea;
            .tab_item {
              margin: 0 24px;
              font-weight: 500;
              font-size: 18px;
              color: #9a9a9c;
              padding-bottom: 5px;
              cursor: pointer;
              border-bottom: 2px solid transparent;
            }
            .active_tab_item {
              color: #000000;
              border-bottom: 2px solid #2270f6;
            }
          }
        }
        .content_box {
          width: 100%;
          height: 290px;
          .no_data {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
            img {
              width: 160px;
              height: 160px;
            }
          }
          .works_data_box {
            padding: 32px;
            box-sizing: border-box;
            .works_data {
              display: flex;
              gap: 20px;
              .work_item {
                flex: 1;
                img {
                  width: 100%;
                  margin-bottom: 3px;
                }
              }
            }
          }
        }
      }
    }
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>